export const getTemtemNumber = (temtem) => {
  let number = temtem.number.toString()
  if (number.length === 1) {
    number = "00" + number;
  } if (number.length === 2) {
    number = "0" + number;
  }

  return number;
}
